import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../../../redux/actions/stepActions";
import GuestBar from "../../../components/GuestInfo/GuestBar";
import {Breadcrumbs, Container, Grid, Link, Typography} from "@mui/material";
import GuestInfoStepper from "../../../components/GuestInfo/GuestInfoStepper";
import Activity from "../../../components/GuestInfo/GuestForm/Activity";
import GuestFormItinerary from "../../../components/GuestInfo/GuestForm/GuestFormItinerary";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {getBookingFormData} from "../../../redux/actions/bookingFormActions";
import {useIsAuthenticated} from "react-auth-kit";
import ValidateAccess from "../../../components/ValidateAccess/ValidateAccess";
import {requestApi, showAlertAutoDis} from "../../../utils/utils";
import {format, parse} from "date-fns";
import PreTripCard from "../../../components/GuestInfo/MyBooking/PreTripCard";


const ExtraActivityOrder = () => {
    ValidateAccess();
    const [activities, setActivities] = useState({'Complimentary': {}, 'Extras': {}});
    const [transactions, setTransactions] = useState({appliedFor: 'all'});
    const {id} = useParams();
    const {booking, form} = useSelector(state => state.bookingForm);
    const isAuth = useIsAuthenticated();
    const history = useHistory();
    let transactionsFromDb = {};

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setStep(4));
    }, []);

    useEffect(() => {
        if (!booking)
            getGuestAndTrip().catch();
    }, [booking?.id]);

    useEffect(() => {
        if (!booking) return;

        getGuestActivities().catch();
        getActivitiesByTrip().catch();
    }, [booking?.id]);


    const getGuestAndTrip = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        dispatch(getBookingFormData(id, accessToken));
    };

    const getGuestActivities = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        const accessQuery = accessToken ? `?guestCode=${accessToken}` : '';
        const {data} = await requestApi(`/guest/get-activities/${id}${accessQuery}`);
        if (data.status === 'success') {
            setTransactions(data.transactions);
            transactionsFromDb = data.transactions;
        }
    };

    const getActivitiesByTrip = async () => {
        const {data} = await requestApi(`/get-activities?tripId=${booking.TripId}`);
        setActivities(data);
    };

    const getTransactionForActivity = (id, isExtra = false) => {
        if (!transactions.activities || !transactions.extra) return '';
        let selectedOption = '';

        if (isExtra) {
            if (Array.isArray(transactions.extra)) return '';
            const extraIdList = Object.keys(transactions.extra);
            selectedOption = extraIdList.includes(id.toString()) ? transactions.extra[id] : '';
        } else {
            if (Array.isArray(transactions.activities)) return '';
            const activityIdList = Object.keys(transactions.activities);
            selectedOption = activityIdList.includes(id.toString()) ? transactions.activities[id] : '';
        }

        return selectedOption;
    };

    const updateActivityTransaction = (id, newValue, isExtra = false) => {
        if (isExtra) {
            let newExtra = {...transactions.extra};
            if (newValue)
                newExtra[id] = newValue;
            else
                delete newExtra[id];
            return setTransactions({...transactions, extra: newExtra});
        } else {
            let newComplimentary = {...transactions.activities}
            if (newComplimentary[id] && newComplimentary[id] === newValue)
                delete newComplimentary[id];
            else
                newComplimentary[id] = newValue;
            return setTransactions({...transactions, activities: newComplimentary});
        }
    };

    const updateTransactions = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        const accessQuery = accessToken ? `?guestCode=${accessToken}` : '';
        const {data} = await requestApi(`/guest/save-activities/${id}${accessQuery}`, 'POST', {transactions: transactions, 'appliedFor': 'all'});
        const redirectRoute = isAuth() ? '/booking/my-bookings' : '/';

        if (data.status === 'success') {
            showAlertAutoDis({title: 'Success', text: 'Your itinerary changes have been saved successfully.', manualClose: true}, () => {
                history.push(redirectRoute);
            });
        }
    };

    return (
        <>
            {isAuth() && booking && <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit"
                          to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography
                        color="text.primary">{form?.guestInfo?.firstName ? `${form.guestInfo.firstName} ${form.guestInfo.lastName}` : 'Guest Form'}</Typography>
                </Breadcrumbs>
            </GuestBar>}
            {booking && <Container>
                <div style={{marginTop: 50}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            {booking.trip && <PreTripCard booking={booking}/>}
                        </Grid>
                        <Grid container spacing={3} style={{marginTop: '20px'}}>
                            <Grid item xs={12} md={9}>
                                {Object.values(activities.Complimentary).length > 0 &&
                                    <Grid item xs={12} style={{marginLeft: '24px'}}>
                                        <Typography variant="h3" component="h3" gutterBottom>
                                            Activities
                                        </Typography>
                                    </Grid>}
                                <Grid item xs={12}>
                                    {Object.values(activities.Complimentary).map(act => (
                                        <Activity key={act.id} activity={act}
                                                  selectedOption={getTransactionForActivity(act.id)}
                                                  handleChange={updateActivityTransaction}/>
                                    ))}
                                </Grid>
                                {Object.values(activities.Extras).length > 0 &&
                                    <Grid item xs={12} style={{marginLeft: '24px', marginBottom: '50px'}}>
                                        <Typography variant="h3" component="h3">
                                            Los Cabos has more to offer <br/>
                                        </Typography>
                                        <Typography variant="h5" align="left">
                                            Extend your stay with one of those special offers.
                                        </Typography>
                                    </Grid>}
                                <Grid item xs={12}>
                                    {Object.values(activities.Extras).map(act => (
                                        <Activity key={act.id} activity={act}
                                                  selectedOption={getTransactionForActivity(act.id, true)}
                                                  handleChange={updateActivityTransaction} extra/>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <GuestFormItinerary trip={booking.trip} activities={{
                                    complimentary: Object.values(activities.Complimentary),
                                    extra: Object.values(activities.Extras)
                                }}
                                    selectedActivities={transactions}
                                    handleConfirm={updateTransactions}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Container>}
        </>
    );
};

export default ExtraActivityOrder;